module.exports = __webpack_public_path__ + "img/dg-nav-below-nav-honda.5c51d6fa.png";